import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ILocationList } from '../../../Pages/Location/ILocation';

export const LocationSlicer = createSlice({
  name: 'Location',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ILocationList[]>,
  reducers: {
    getLocation: (state) => {
      state.isLoading = true;
    },
    successGetLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getLocation, failureGetLocation, successGetLocation } =
  LocationSlicer.actions;

export default LocationSlicer.reducer;
